import type { CSSProperties, FC } from 'react'

import { Fragment } from 'react'
import { cn } from '@/lib/utils'

interface SplitWordsProps {
    text: string
    className?: string
    wordClassName?: string
    innerClassName?: string
    style?: CSSProperties
    /** Stagger step in seconds, exposed to CSS as --d on each word for load-time entrances. */
    stagger?: number
    delay?: number
}

/** Renders each word inside its own clipping mask so it can rise into view. Server-rendered, no measuring. */
export const SplitWords: FC<SplitWordsProps> = ({
    text,
    className,
    wordClassName,
    innerClassName,
    style,
    stagger,
    delay = 0
}) => {
    const words = text.split(' ')

    return (
        <span className={className} style={style}>
            {words.map((word, index) => (
                <Fragment key={`${word}-${index}`}>
                    <span className={cn('line-mask', wordClassName)}>
                        <span
                            data-word=''
                            className={innerClassName}
                            style={stagger !== undefined ? ({ '--d': `${delay + index * stagger}s` } as CSSProperties) : undefined}
                        >
                            {word}
                        </span>
                    </span>

                    {index < words.length - 1 ? ' ' : null}
                </Fragment>
            ))}
        </span>
    )
}
